module.exports = __webpack_public_path__ + "media/Indoor Stretching.2b8d642a.mp4";